<template>
  <v-layout id="post-list">
        <v-flex xs12 sm10 md8 lg6 offset-sm1 offset-md2 offset-lg3>
          <v-card v-for="(post, key) in posts" :key="key" class="post-preview">

            <v-card-title primary-title>
              <div>
                <router-link :to="`/post/${post.permalink}`"><a><h3 class="headline mb-0">{{ post.title }}</h3></a></router-link>
                <div class="post-content"> {{ post.content | shortText }}... </div>
              </div>
            </v-card-title>

            <v-card-actions>
              <router-link :to="`/post/${post.permalink}`"><v-btn flat color="blue">Read More</v-btn></router-link>
            </v-card-actions>
          </v-card>
        </v-flex>
  </v-layout>
</template>

<script>
    import { GET_POSTS, FETCH_POSTS } from '../store/types';

    export default {
        computed: {
            posts() {
                return this.$store.getters[GET_POSTS];
            }
        },
        filters: {
            shortText(val) {
                if (typeof val === 'string') {
                    return val.substring(0, 500);
                }
            }
        },
        created() {
            this.$store.dispatch(FETCH_POSTS);
        }
    }
</script>

<style>
  #post-list {
    margin-top: 50px;
  }
  h3 {
    text-align: left;
    color: #000 !important;
  }
  .post-content {
    margin-top: 20px;
    text-align: left;
  }
  .post-preview {
    padding: 20px;
  }
</style>
